<!-- @format -->

<template>
  <a-modal
    :destroyOnClose="true"
    centered
    width="800px%"
    :title="vm.detailDialogType"
    :visible="visible"
    :okText="isSubmiting ? '提交中...' : '确定'"
    cancelText="取消"
    @ok="handleSubmit"
    @cancel="$emit('cancel')"
  >
    <superFieldInfoList ref="firstSuperFieldInfoList" :group="['卡片信息', '客户信息']" :vm="vm" />
    <h4 class="mt20">车辆信息</h4>
    <div width="100%">
      <a-form ref="myForm" :form="form" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
        <div
          style="position:relative;"
          v-for="(k, index) in form.getFieldValue('keys')"
          :key="k"
          v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
        >
          <a-row>
            <a-col :span="7">
              <a-form-item :colon="false" label="车牌号">
                <!-- {{index}} -->
                <PlateInput
                  :default-plate="models[index].plate"
                  :params="{ index: index }"
                  v-decorator="[
                    `plate${index}`,
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入正确车牌号',
                          pattern: /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领临民]{1}[A-HJ-NP-Z0-9\u4e00-\u9fa5]{6,7}$)|(^[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9\u4e00-\u9fa5]{6,8}$)/
                        }
                      ]
                    }
                  ]"
                  @plateChange="handlePlateChange"
                />
                <!--            <a-input defaultValue="222" />-->
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :colon="false" label="车型">
                <a-select v-model="models[index].carType">
                  <a-select-option value="01">小型车</a-select-option>
                  <a-select-option value="00">大型车</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :colon="false" label="品牌">
                <a-input v-model.trim="models[index].brand" />
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :colon="false" label="颜色">
                <a-input v-model.trim="models[index].color" />
              </a-form-item>
            </a-col>
            <a-col :offset="1" :span="1">
              <a-icon
                style="position:relative;left:-100%;top:6px;"
                v-if="form.getFieldValue('keys').length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :disabled="form.getFieldValue('keys').length === 1"
                @click="() => remove(k, index)"
              />
            </a-col>
          </a-row>
        </div>
        <div style="margin-left:6%;position:relative;margin-bottom:10px;">
          <a-button @click="add(null)"> <a-icon type="plus" />添加车牌 </a-button>
        </div>
      </a-form>
    </div>

    <superFieldInfoList
      ref="lastSuperFieldInfoList"
      :group="['充值信息']"
      :vm="vm"
      where="detailModel.config.3.fields"
    />
  </a-modal>
</template>

<script>
/** @format */
import superFieldInfoList from '@/components/super-field-info-list/index';
import PlateInput from '../../../components/plate-input/index.vue';
import { IForm } from '@/views/parking-lot-management/device-list/components/add-device-form';
import * as _ from 'lodash';
import { commitModifyCar, quertMonthCardDetail, getPlate } from '../../../api/fixed-car-management/index';
let id = 0;

function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

  while (el) {
    if (matchesSelector.call(el, selector)) {
      break;
    }
    el = el.parentElement;
  }
  return el;
}

export default {
  props: {
    visible: Boolean,
    vm: Object
  },
  components: {
    PlateInput,
    superFieldInfoList
  },
  data() {
    return {
      isSubmiting: false,
      test: '',
      models: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      },
      defaultPlate: ''
    };
  },

  computed: {
    firstPartDetailModelConfig() {
      return {
        config: this.vm.detailModel.config.slice(0, 2),
        data: this.vm.detailModel.data
      };
    },
    lastPartDetailModelConfig() {
      return {
        config: [this.vm.detailModel.config[3]],
        data: this.vm.detailModel.data
      };
    }
  },
  mounted() {
    this.getPlateList();

    this.vm.evtBus.$on('B_SET_DEFAULT_PLATE_HEAD', args => {
      this.defaultPlate = args[1];

      this.setDefaultPlateHead();
    });

    // B_SET_DEFAULT_PLATE_HEAD
    // this.vm.detailModel.data.storedCardPlateList.forEach((model, index) => {
    //   this.add(model)
    //   this.form.setFieldsValue({
    //     ['plate' + index]: model.plate,
    //   })
    // })
    // let tempClickEvetHandler = e => {
    //   this.windowEventTarget = e.target
    // }
    // this.tempClickEvetHandler = tempClickEvetHandler
    // this.$refs.myForm.$el.addEventListener('click', tempClickEvetHandler)

    // this.$refs.myForm.$el.addEventListener('keyup', tempClickEvetHandler)
  },
  // beforeDestroy () {
  //   this.$refs.myForm.$el.removeEventListener('click', this.tempClickEvetHandler)
  //   // this.$refs.myForm.$el.removeEventListener('keyup', this.tempClickEvetHandler)
  // },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
  },
  methods: {
    setDefaultPlateHead() {
      this.$nextTick(() => {
        try {
          this.models.forEach((model, index) => {
            console.log('model--:', model);
            if (model.plate.trim() == '') {
              model.plate = this.defaultPlate;
            }
            this.form.setFieldsValue({
              ['plate' + index]: model.plate
            });
          });
        } catch (e) {
          console.warn('e--', e);
          void 0;
        }
      });
    },
    //根据车场获取默认车牌所在地
    // async getPlateNum () {
    //   try {
    //     const { data } = await getPlate({ parkId: this.filterParam.parkId })
    //     this.defaultPlate = data.plateHead || ''
    //     if (!this.filterParam.plateList[0].plate) return (this.filterParam.plateList[0].plate = this.defaultPlate)
    //   } catch (error) {
    //     this.$message.error((error && error.msg) || '未获取到该车场的默认车牌所在地')
    //   }
    // },
    async getPlateList() {
      // B_SET_DEFAULT_PLATE_HEAD
      this.vm.detailModel.data.storedCardPlateList.forEach((model, index) => {
        this.add(model);
        this.form.setFieldsValue({
          ['plate' + index]: model.plate
        });
      });
      this.vm.getVMData('detailModel.data.storedCardPlateList').forEach((item, index) => {
        this.vm.transformDictCnName2Int(`detailModel.data.storedCardPlateList.${index}.carType`, 'car_forbid_type');
      });
    },
    async handleSubmit() {
      const fieldInfoListArr = [this.form, this.$refs.firstSuperFieldInfoList, this.$refs.lastSuperFieldInfoList],
        rightArr = new Array(fieldInfoListArr.length).fill(false);
      fieldInfoListArr.forEach((item, index) => {
        ('getForm' in (item.form || {}) ? item.form.getForm() : item).validateFields(err => {
          if (!err) {
            rightArr[index] = true;
          }
        });
      });

      if (
        !rightArr
          .map(v => v - 0)
          .join('')
          .includes('0')
      ) {
        // alert('ok')
        const formData = await this.getFormValue();
        this.vm.mixedUtils.log('form data---:', formData);

        this.isSubmiting = true;
        setTimeout(() => {
          this.$emit(
            'submit',
            {
              ...this.vm.detailModel.data,
              storedCardPlateList: formData
            },
            error => {
              // this.$message.error(this.vm.getHttpErrorMsg(error))
              this.isSubmiting = false;
            }
          );
        }, 300);
      }
    },
    validate(cb) {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          cb(values);
        }
      });
    },
    handlePlateChange([head, tail], p) {
      head = head || '';
      tail = tail || '';
      try {
        const index = p.index;
        this.models[index].plate = head + tail;
        this.form.setFieldsValue({
          ['plate' + index]: head + tail
        });
        // console.log(this.form.getFieldsValue())
      } catch (e) {
        console.warn('e--', e);
        void 0;
      }
    },
    remove(k, index) {
      const { form } = this;

      const keys = form.getFieldValue('keys');
      if (keys.length === 1) {
        return;
      }
      // alert(keys.filter(key => key !== k).map((mapIndex) => mapIndex))

      form.setFieldsValue({
        keys: keys.filter(key => key !== k).map((v, mapIndex) => mapIndex)
      });

      this.models.splice(index, 1);

      // this.$nextTick(()=>{

      // })
      this.models.forEach((item, index) => {
        form.setFieldsValue({
          ['plate' + index]: item.plate
        });
      });
      // this.getPlateList()
    },

    modelAdd(model) {
      this.models.push(
        model || {
          plate: '',
          carType: '01',
          brand: '',
          color: ''
        }
      );
      this.setDefaultPlateHead();
    },
    modelRemove() {},
    getFormValue() {
      return new Promise((resolve, reject) => {
        if (this.models.length == 0) {
          this.$message.error('车牌列表不能为空');
          return false;
        }
        this.validate(values => {
          let hasError = false;
          this.models.forEach((model, index) => {
            if (model.plate.length <= 2 || !new RegExp('^[\u4e00-\u9fa5]').test(model.plate)) {
              hasError = true;
              const rowNo = index + 1;
              this.$message.error('车辆信息第' + rowNo + '行：请输入完整且格式合法的车牌号');
            }
          });
          if (!hasError) {
            // let fieldsValue = this.form.getFieldsValue()
            // let clonedModels = _.cloneDeep(this.models)
            // clonedModels.forEach((item, index) => {
            //   item.carType = fieldsValue['carType' + index]
            // })
            // resolve(clonedModels)
            resolve(this.models);
          }
        });
      });
    },
    //添加车牌
    add(model = null) {
      const { form } = this;
      const keys = form.getFieldValue('keys');
      const nextKeys = keys.concat(id++);
      form.setFieldsValue({
        keys: nextKeys.map((v, mapIndex) => mapIndex)
      });
      this.modelAdd(model);
    }
  }
};
</script>
<style>
/** @format */

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
